/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CookieTokenRefresh,
  CookieTokenRefreshRequest,
  CustomTokenObtainPairRequest,
  PatchedUserProfileRequest,
  TokenVerifyRequest,
  UserInfoUserProfileSerializerResponse,
  UserProfileRequest
} from '../../models';

import { customInstance } from '../../../axios-instance';




export const authLogoutCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/logout/`, method: 'POST', signal
    },
      );
    }
  


export const getAuthLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,void, TContext> => {

const mutationKey = ['authLogoutCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogoutCreate>>, void> = () => {
          

          return  authLogoutCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authLogoutCreate>>>
    
    export type AuthLogoutCreateMutationError = unknown

    export const useAuthLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogoutCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Takes a refresh type JSON web token and returns an access type JSON web
token if the refresh token is valid.
 */
export const authRefreshTokenCreate = (
    cookieTokenRefreshRequest: CookieTokenRefreshRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CookieTokenRefresh>(
      {url: `/api/auth/refresh_token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cookieTokenRefreshRequest, signal
    },
      );
    }
  


export const getAuthRefreshTokenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefreshTokenCreate>>, TError,{data: CookieTokenRefreshRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRefreshTokenCreate>>, TError,{data: CookieTokenRefreshRequest}, TContext> => {

const mutationKey = ['authRefreshTokenCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRefreshTokenCreate>>, {data: CookieTokenRefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  authRefreshTokenCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthRefreshTokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authRefreshTokenCreate>>>
    export type AuthRefreshTokenCreateMutationBody = CookieTokenRefreshRequest
    export type AuthRefreshTokenCreateMutationError = unknown

    export const useAuthRefreshTokenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefreshTokenCreate>>, TError,{data: CookieTokenRefreshRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRefreshTokenCreate>>,
        TError,
        {data: CookieTokenRefreshRequest},
        TContext
      > => {

      const mutationOptions = getAuthRefreshTokenCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Takes a set of user credentials and returns an access and refresh JSON web
token pair to prove the authentication of those credentials.
 */
export const authTokenCreate = (
    customTokenObtainPairRequest: CustomTokenObtainPairRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customTokenObtainPairRequest, signal
    },
      );
    }
  


export const getAuthTokenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authTokenCreate>>, TError,{data: CustomTokenObtainPairRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authTokenCreate>>, TError,{data: CustomTokenObtainPairRequest}, TContext> => {

const mutationKey = ['authTokenCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authTokenCreate>>, {data: CustomTokenObtainPairRequest}> = (props) => {
          const {data} = props ?? {};

          return  authTokenCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthTokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authTokenCreate>>>
    export type AuthTokenCreateMutationBody = CustomTokenObtainPairRequest
    export type AuthTokenCreateMutationError = unknown

    export const useAuthTokenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authTokenCreate>>, TError,{data: CustomTokenObtainPairRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authTokenCreate>>,
        TError,
        {data: CustomTokenObtainPairRequest},
        TContext
      > => {

      const mutationOptions = getAuthTokenCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Enhanced RetrieveUpdateAPIView that automatically provides all Citrus functionality
for retrieve and update operations.

Usage:
    @extend_schema(tags=['Authentication'])
    class UserInfoView(CitrusRetrieveUpdateAPIView):
        serializer_class = UserSerializer

        def get_object(self):
            return self.request.user
 * @summary Get userprofile
 */
export const authUserinfoRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserInfoUserProfileSerializerResponse>(
      {url: `/api/auth/userinfo/`, method: 'GET', signal
    },
      );
    }
  

export const getAuthUserinfoRetrieveQueryKey = () => {
    return [`/api/auth/userinfo/`] as const;
    }

    
export const getAuthUserinfoRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthUserinfoRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authUserinfoRetrieve>>> = ({ signal }) => authUserinfoRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthUserinfoRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof authUserinfoRetrieve>>>
export type AuthUserinfoRetrieveQueryError = unknown


export function useAuthUserinfoRetrieve<TData = Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authUserinfoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authUserinfoRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthUserinfoRetrieve<TData = Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authUserinfoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authUserinfoRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthUserinfoRetrieve<TData = Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get userprofile
 */

export function useAuthUserinfoRetrieve<TData = Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authUserinfoRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthUserinfoRetrieveQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Enhanced RetrieveUpdateAPIView that automatically provides all Citrus functionality
for retrieve and update operations.

Usage:
    @extend_schema(tags=['Authentication'])
    class UserInfoView(CitrusRetrieveUpdateAPIView):
        serializer_class = UserSerializer

        def get_object(self):
            return self.request.user
 * @summary Update userprofile (full)
 */
export const authUserinfoUpdate = (
    userProfileRequest: UserProfileRequest,
 ) => {
      
      
      return customInstance<UserInfoUserProfileSerializerResponse>(
      {url: `/api/auth/userinfo/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userProfileRequest
    },
      );
    }
  


export const getAuthUserinfoUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUserinfoUpdate>>, TError,{data: UserProfileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authUserinfoUpdate>>, TError,{data: UserProfileRequest}, TContext> => {

const mutationKey = ['authUserinfoUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUserinfoUpdate>>, {data: UserProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  authUserinfoUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUserinfoUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof authUserinfoUpdate>>>
    export type AuthUserinfoUpdateMutationBody = UserProfileRequest
    export type AuthUserinfoUpdateMutationError = unknown

    /**
 * @summary Update userprofile (full)
 */
export const useAuthUserinfoUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUserinfoUpdate>>, TError,{data: UserProfileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUserinfoUpdate>>,
        TError,
        {data: UserProfileRequest},
        TContext
      > => {

      const mutationOptions = getAuthUserinfoUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Enhanced RetrieveUpdateAPIView that automatically provides all Citrus functionality
for retrieve and update operations.

Usage:
    @extend_schema(tags=['Authentication'])
    class UserInfoView(CitrusRetrieveUpdateAPIView):
        serializer_class = UserSerializer

        def get_object(self):
            return self.request.user
 * @summary Update userprofile
 */
export const authUserinfoPartialUpdate = (
    patchedUserProfileRequest: PatchedUserProfileRequest,
 ) => {
      
      
      return customInstance<UserInfoUserProfileSerializerResponse>(
      {url: `/api/auth/userinfo/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUserProfileRequest
    },
      );
    }
  


export const getAuthUserinfoPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUserinfoPartialUpdate>>, TError,{data: PatchedUserProfileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authUserinfoPartialUpdate>>, TError,{data: PatchedUserProfileRequest}, TContext> => {

const mutationKey = ['authUserinfoPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUserinfoPartialUpdate>>, {data: PatchedUserProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  authUserinfoPartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUserinfoPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof authUserinfoPartialUpdate>>>
    export type AuthUserinfoPartialUpdateMutationBody = PatchedUserProfileRequest
    export type AuthUserinfoPartialUpdateMutationError = unknown

    /**
 * @summary Update userprofile
 */
export const useAuthUserinfoPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUserinfoPartialUpdate>>, TError,{data: PatchedUserProfileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUserinfoPartialUpdate>>,
        TError,
        {data: PatchedUserProfileRequest},
        TContext
      > => {

      const mutationOptions = getAuthUserinfoPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Takes a token and indicates if it is valid.  This view provides no
information about a token's fitness for a particular use.
 */
export const authValidateTokenCreate = (
    tokenVerifyRequest: TokenVerifyRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/validate_token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenVerifyRequest, signal
    },
      );
    }
  


export const getAuthValidateTokenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authValidateTokenCreate>>, TError,{data: TokenVerifyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authValidateTokenCreate>>, TError,{data: TokenVerifyRequest}, TContext> => {

const mutationKey = ['authValidateTokenCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authValidateTokenCreate>>, {data: TokenVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  authValidateTokenCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthValidateTokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authValidateTokenCreate>>>
    export type AuthValidateTokenCreateMutationBody = TokenVerifyRequest
    export type AuthValidateTokenCreateMutationError = unknown

    export const useAuthValidateTokenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authValidateTokenCreate>>, TError,{data: TokenVerifyRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authValidateTokenCreate>>,
        TError,
        {data: TokenVerifyRequest},
        TContext
      > => {

      const mutationOptions = getAuthValidateTokenCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    